import {getMethod, putMethod} from '~/api'

async function get(hotelId, request) {
    return await getMethod(`/api/hotelTags/${hotelId}`, request)
}

async function put(hotelId, request) {
    return await putMethod(`/api/hotelTags/${hotelId}`, request)
}

export {get, put}
